import { render, staticRenderFns } from "./UsageBar.vue?vue&type=template&id=2b792422&scoped=true&"
import script from "./UsageBar.vue?vue&type=script&lang=js&"
export * from "./UsageBar.vue?vue&type=script&lang=js&"
import style0 from "./UsageBar.vue?vue&type=style&index=0&id=2b792422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b792422",
  null
  
)

export default component.exports